document.addEventListener('DOMContentLoaded', () => {
    const DEBUG = false;
    function log(...args) {
        if (DEBUG) {
            console.log(...args);
        }
    }
    function isVisible(element) {
        if (!element) return false;
        for (let current = element; current; current = current.parentElement) {
            const style = window.getComputedStyle(current);
            if (
                style.display === 'none' ||
                style.visibility === 'hidden' ||
                parseFloat(style.opacity) === 0
            ) {
                log('Element is not visible due to:', current, style);
                return false;
            }
        }
        return true;
    }
    function getFilteredElements(selector) {
        const elements = document.querySelectorAll(selector);
        log(`Found ${elements.length} elements for selector "${selector}"`);
        let filtered = [];
        elements.forEach(item => {
            if (isVisible(item) && item.innerHTML.trim() !== '') {
                filtered.push(item);
                log('Added element:', item);
            } else {
                log('Skipped element:', item);
            }
        });
        if (filtered.length > 1) {
            filtered = filtered.filter(item => {
                let parent = item.parentElement;
                while (parent) {
                    if (filtered.includes(parent)) {
                        log('Removing nested element:', item, 'because its parent', parent, 'is in the list');
                        return false;
                    }
                    parent = parent.parentElement;
                }
                return true;
            });
        }
        log(`Filtered elements for selector "${selector}":`, filtered);
        return filtered;
    }
    function waitForElement(selector, callback) {
        const intervalId = setInterval(() => {
            const elements = getFilteredElements(selector);
            if (elements.length > 0) {
                clearInterval(intervalId);
                log(`Element found for selector "${selector}":`, elements[0]);
                callback(elements[0]);
            } else {
                log(`Waiting for element matching "${selector}"...`);
            }
        }, 500);
    }
    const productPriceItems = getFilteredElements('.product .price-item');
    const productPriceItem = productPriceItems[0];
    if (!productPriceItem) {
        log("Product price item not found.");
    } else {
        log("Product price item found:", productPriceItem);
        const productContainer = productPriceItem.parentElement;
        waitForElement('.floating-buy-bar .price-item', function (floatingPriceItem) {
            const floatingContainer = floatingPriceItem.parentElement;
            function syncPrices() {
                const productDiscounted = productContainer.querySelector('.price-item--sale');
                const productOriginal = productContainer.querySelector('.price-item--regular');
                const floatingDiscounted = floatingContainer.querySelector('.price-item--sale');
                const floatingOriginal = floatingContainer.querySelector('.price-item--regular');
                if (productDiscounted && floatingDiscounted) {
                    log("Syncing discounted price. Old floating value:", floatingDiscounted.innerHTML);
                    floatingDiscounted.innerHTML = productDiscounted.innerHTML;
                    log("New floating discounted value:", floatingDiscounted.innerHTML);
                }
                if (productOriginal && floatingOriginal) {
                    log("Syncing original price. Old floating value:", floatingOriginal.innerHTML);
                    floatingOriginal.innerHTML = productOriginal.innerHTML;
                    log("New floating original value:", floatingOriginal.innerHTML);
                }
            }
            syncPrices();
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        log("Mutation observed:", mutation);
                        syncPrices();
                    }
                });
            });
            observer.observe(productContainer, {
                childList: true,
                subtree: true,
                characterData: true
            });
            log("Binding complete: Floating price elements are now synced with the product price container.");
        });
    }
});